import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", null, " Перетащите фото "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", null, " или "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", null, " нажмите ")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Загрузить фото ")
const _hoisted_3 = { class: "el-upload__tip" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_upload, {
      drag: "",
      multiple: "",
      accept: ['image/png', 'image/jpeg'],
      "list-type": "picture-card",
      class: "upload-demo",
      "auto-upload": false,
      "file-list": _ctx.photosList,
      "on-change": _ctx.handleChangeUpload,
      "on-remove": _ctx.handleRemoveUpload,
      "on-preview": _ctx.handlePreviewUpload
    }, {
      tip: _withCtx(() => [
        _createElementVNode("p", _hoisted_3, _toDisplayString(`Макс. ${_ctx.rules.upload.common.filesLength.max.value} файлов, jpg/png файлы размером менее, чем ${_ctx.rules.upload.common.fileSize.max.label}`), 1)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["file-list", "on-change", "on-remove", "on-preview"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "el-dialog-img_full",
          src: _ctx.dialogImageUrl,
          alt: "Предпросмотр фото"
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}